import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${theme.layout.breakpoints.sm}) {
      display: grid;
      gap: ${theme.layout.spacing(1)};
      grid-template-columns: repeat(auto-fit, 45px);
    }
  `}
`;

export const SelectionButton = styled.button`
  ${({ theme }) => css`
    width: 40px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;

    outline: none;
    cursor: pointer;
    border-radius: 12px;
    border: 2px solid ${theme.palette.primary.main};

    font-size: 1.25rem;
    font-weight: ${theme.typography.weight.bold};

    color: ${theme.palette.primary.main};
    background-color: transparent;

    &[data-selected='true'] {
      color: ${theme.palette.text.white};
      background-color: ${theme.palette.primary.main};
    }

    transition: 0.3s;

    &:hover {
      background-color: ${transparentize(0.8, theme.palette.primary.main)};
    }
  `}
`;
